import AccountList from "../Component/AccountList";
import { connect } from 'react-redux';
import {
  getAccountListing,
  getAccountListingTab,
  getCustomers,
  getFranchiseList,
  addManualPayment,
  deleteAccountInvoice,
  getExpiredCardListing,
  resendInvoiceAPI,
  VoidInvoiceAPI,
  getSalesByItem,
  getOverViewInvoice,
  sendInvoice,
  getWorkOrders,
  getWorkOrdersSummary,
  getAccountAggingSummary,
  suspendAccountAggingSummary,
  getMonthlyForecast,
  getMonthForecastCSV,
  getSingleInvoice,
  updateSingleInvoice,
  deleteSingleInvoice,
  approveSendInvoice,
  printInvoice,
  sendInvoiceReminder,
  getPaymentHistory,
  getCardList,
  addNewCard,
  getUserList,
  getServiceOrderNumberList,
  getQuickbooksSync,
  getStaffUsers,
  getServiceOrderById,
  refundPaymentAccounting,
  batchInvoice,
  getSalesTaxSummary,
  getStaxCustomerDetail,
  generateInvoice,
  postPaymentLog,
  getInvoiceCreditMemoList,
  getInvoiceSummary,
  remainingCreditBalance,
  getInvoiceList,
  addManualInvoice,
  deleteInvoice,
  resendInvoice,
  finalizeInvoice,
  getInvoiceDescription,
  getInvoiceById,
  getSalesTax,
  getWorkOrderList,
  getWorkOrderDetail,
  getCommercialWorkOrder,
  getCustomerDetail,
  getCommercialCustomer,
  addPaymentLog,
  invoiceProcess,
  deletePaymentLog,
  invoiceEmailSend,
  getMonthlyForecastTotal,
  getAllAcountingListUuid
} from '../../../../Action';

const mapStateToProps = (state) => {
  const { 
    Invoice,
    CardList,
    GetManualy,
    GetTabData,
    GetSuspend,
    WorkOrders,
    WorkOrdersSummary,
    ExpiredCard,
    VoidInvoice,
    SalesByItem,
    BatchInvoice,
    CustomerList,
    StaxCustomer,
    DeleteInvoice,
    ResendInvoice,
    FranchiseList,
    SingleInvoice,
    AggingSummary,
    RefundPayment,
    GetAccountList, 
    PrintedInvoice,
    PaymentHistory,
    InvoiceOverView,
    MonthlyForecast, 
    DeleteLineItems,
    FinalizeInvoice,
    AddCard,
    UserList,
    GetQuickbooksSync,
    UpdateSingleInvoice,
    SendInvoiceReminder,
    GetGeneratedInvoice,
    PostPaymentLog,
    RemainingCreditBalance,
    ServiceOrder,
    InvoiceDescription,
    workOrderList,
    WorkOrderDetail,
    CommercialWorkOrder,
    CommercialCustomer,
    InvoiceProcess,
    InvoiceEmailSend,
    MonthlyForecastTotal,
    GetAllAcountingListUuid
  } = state;

  return {
    Invoice,
    CardList,
    GetManualy,
    GetTabData,
    GetSuspend,
    WorkOrders,
    WorkOrdersSummary,
    ExpiredCard,
    VoidInvoice,
    SalesByItem,
    BatchInvoice,
    CustomerList,
    StaxCustomer,
    DeleteInvoice,
    ResendInvoice,
    FranchiseList,
    SingleInvoice,
    AggingSummary,
    RefundPayment,
    GetAccountList,
    PrintedInvoice,
    PaymentHistory,
    InvoiceOverView,
    MonthlyForecast,
    DeleteLineItems,
    FinalizeInvoice,
    AddCard,
    UserList,
    GetQuickbooksSync,
    InvoiceDescription,
    UpdateSingleInvoice,
    SendInvoiceReminder,
    GetGeneratedInvoice,
    PostPaymentLog,
    RemainingCreditBalance,
    ServiceOrder,
    workOrderList,
    WorkOrderDetail,
    CommercialWorkOrder,
    CommercialCustomer,
    InvoiceProcess,
    InvoiceEmailSend,
    MonthlyForecastTotal,
    GetAllAcountingListUuid
  }
}
const actionCreators = {
  getCardList,
  getAccountListingTab,
  suspendAccountAggingSummary,
  getWorkOrders,
  getWorkOrdersSummary,
  getExpiredCardListing,
  VoidInvoiceAPI,
  getSalesByItem,
  batchInvoice,
  getCustomers,
  getStaxCustomerDetail,
  deleteSingleInvoice,
  resendInvoiceAPI,
  getFranchiseList,
  getSingleInvoice,
  getAccountAggingSummary,
  refundPaymentAccounting,
  getAccountListing,
  printInvoice,
  getPaymentHistory,
  getOverViewInvoice,
  getMonthlyForecast,
  getMonthForecastCSV,
  deleteAccountInvoice,
  addNewCard,
  getUserList,
  getQuickbooksSync,
  getInvoiceDescription,
  updateSingleInvoice,
  sendInvoiceReminder,
  getSalesTaxSummary,
  getStaffUsers,
  addManualPayment,
  sendInvoice,
  approveSendInvoice,
  getServiceOrderNumberList,
  getServiceOrderById,
  getSalesTax, 
  generateInvoice,
  postPaymentLog,
  getInvoiceCreditMemoList,
  getInvoiceSummary,
  remainingCreditBalance,
  getInvoiceList,
  getInvoiceById,
  addManualInvoice,
  deleteInvoice,
  resendInvoice,
  finalizeInvoice,
  getWorkOrderList,
  getWorkOrderDetail,
  getCommercialWorkOrder,
  getCustomerDetail,
  getCommercialCustomer,
  addPaymentLog,
  invoiceProcess,
  deletePaymentLog,
  invoiceEmailSend,
  getMonthlyForecastTotal,
  getAllAcountingListUuid
}

export default (connect(mapStateToProps, actionCreators)(AccountList));